import styled from "styled-components";
import AppWrapper from "../../../../layout/AppWrapper";
import Title from "../../../../utils/Title";
import BestSellingCategory from "../BestSellingCategory";
import { useEffect } from "react";
import BackButton from "../../../BackButton";
import CustomChart from "../../../../utils/CustomChart";
import { useState } from "react";
import TopSellingProduct from "../TopSellingProduct";
import BestSellingProduct from "../BestSellingProduct";
import { useReportContext } from "../../../../context/report_context";
import BusinessReportOverview from "./BusinessReportOverview";
import FilterReport from "../FilterReport";



const BusinessReport = () => {

      const [year, setYear] = useState('');
      const [month, setMonth] = useState('');

      const getCurrentMonthYear = () => {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // add leading zero
            return `${ year }-${ month }`;
      };

      const [key, setkey] = useState('');

      useEffect(() => {
            getCurrentMonthYear();
            setkey(getCurrentMonthYear());
            if (key) {
                  const [yr, mo] = key.split("-");
                  const monthNames = [
                        "January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                  ];
                  const monthIndex = parseInt(mo, 10) - 1;

                  setYear(yr);
                  setMonth(monthNames[monthIndex]);
            }
      }, [key]);


      const { handleBusinessFilter, businessChart, businessTopSell, businessBestSell, isFetching } = useReportContext();

      useEffect(() => {
            handleBusinessFilter({ month, year });
      }, [month, year]);

      const filterData = { year, month, setMonth, setYear };

      return (
            <AppWrapper
                  pagename={'reports'}
            >
                  <StyledBusinessReport>
                        <Title title={"Overall Business"} btnName={""} />
                        <BackButton />

                        <FilterReport
                              {...filterData}
                        />

                        <section className="row">
                              <div className="col-md-8">
                                    <BusinessReportOverview />
                              </div>
                              <div className="mt-4 mt-md-0 col-md-4">
                                    <BestSellingCategory />
                              </div>
                        </section>
                        <section className="my-3">
                              <CustomChart
                                    title={'Overview Chart'}
                                    chartData={businessChart}
                                    loading={isFetching}
                              />
                        </section>
                        <section className="gap-3 gap-md-0 my-3 row">
                              <div className="col-md-6">
                                    <TopSellingProduct
                                          businessTopSell={businessTopSell}
                                    />
                              </div>
                              <div className="col-md-6">
                                    <BestSellingProduct
                                          businessBestSell={businessBestSell}
                                    />
                              </div>

                        </section>

                  </StyledBusinessReport>
            </AppWrapper>
      );
};

export default BusinessReport;

const StyledBusinessReport = styled.div`
      

`;